import React, { useState, useEffect } from 'react';
import API from '../api';
import SEO from "../components/SEO";

const MentorApplicationPage = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    profile: '',
    expertise: '',
    availability: '',
    bio: '',
  });
  const [status, setStatus] = useState(null);

  // Ensure the page scrolls to top whenever this page is navigated to or the id changes
      useEffect(() => {
          try {
              if (typeof window !== 'undefined' && window?.scrollTo) {
                  // instant jump to top to avoid flashing at previous scroll position
                  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
              }
          } catch (e) {
              // fallback: simple assignment
              try {
                  window.scrollTo(0, 0);
              } catch (err) {
                  // ignore in environments without window
              }
          }
      }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    const payload = { ...form };

    try {
      if (API && API.post) {
        await API.post('/alumni/mentors/apply', payload);
      } else {
        console.log('Mentor application payload', payload);
      }
      setStatus('success');
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  const pageUrl = typeof window !== 'undefined' ? window.location.href : 'https://africaresearchuniversity.com/alumni/mentors/apply';
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': 'Apply to be a Mentor - Africa Research University',
    'description': 'Apply to join ARU mentorship programmes and support students.',
    'url': pageUrl
  };

  return (
    <section className="min-h-screen py-16 bg-gray-50">
      <SEO title="Become a Mentor — Africa Research University" description="Apply to join ARU mentorship programmes and support students." image="/assets/img/arulogo.png" url={pageUrl} jsonLd={jsonLd} />
      <div className="max-w-3xl my-16 mx-auto px-6">
        <div className="flex items-center mb-6">
            <a href="/alumni?tab=get-involved" className="flex items-center text-blue-600 hover:text-blue-800">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Back to Alumni
            </a>
        </div>
        <h1 className="text-2xl md:text-3xl font-bold mb-4">Apply to be a Mentor</h1>
        <p className="text-gray-600 mb-6">Share your experience and support current students by becoming a mentor.</p>

        <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input name="name" value={form.name} onChange={handleChange} placeholder="Full name" className="p-3 border rounded" required />
            <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email" className="p-3 border rounded" required />
            <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone" className="p-3 border rounded" />
            <input name="profile" value={form.profile} onChange={handleChange} placeholder="LinkedIn or Profile URL" className="p-3 border rounded" />
            <input name="expertise" value={form.expertise} onChange={handleChange} placeholder="Expertise areas (comma separated)" className="p-3 border rounded md:col-span-2" />
            <input name="availability" value={form.availability} onChange={handleChange} placeholder="Availability (e.g., evenings, weekends)" className="p-3 border rounded md:col-span-2" />
            <textarea name="bio" value={form.bio} onChange={handleChange} placeholder="Short bio" className="p-3 border rounded md:col-span-2" />
          </div>

          <div className="mt-4 flex items-center gap-3">
            <button type="submit" className="px-5 py-2 bg-green-600 text-white rounded">Submit Application</button>
            {status === 'submitting' && <span className="text-sm">Submitting...</span>}
            {status === 'success' && <span className="text-sm text-green-600">Application submitted</span>}
            {status === 'error' && <span className="text-sm text-red-600">Submission failed</span>}
          </div>
        </form>
      </div>
    </section>
  );
};

export default MentorApplicationPage;
